<p-dialog header="{{title}}" [(visible)]="display" [responsive]="true" showEffect="fade" [modal]="true" *ngIf="display" appendTo="body">

    <!-- #region BODY -->
    <div class="container-md">

        <!-- DRIVER -->
        <div class="row justify-content-start mt-3">
            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
                    <strong>{{ 'tableManagement.fine.driver' | translate }} (*)</strong>
                </label>
                <div class="p-3"></div>
                <p-dropdown
                    [options]="driverList"
                    [(ngModel)]="entity.driver"
                    placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.fine.driver' | translate }}"
                    dataKey="id"
                    optionLabel="fullName"
                    [style]="{ width: '250px' }"
                    appendTo="body"
                    [filter]="true"
                    (onChange)="onChangeDriver($event)"
                    (onFilter)="onFilterDriver($event)"                  
                >
                    <ng-template let-driver pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>
                                ({{ driver.employee.code }}) {{ driver.employee.user.surname1 }} {{ driver.employee.user.surname2 }} 
                                {{ driver.employee.user.name }}
                            </div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>

            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
					<strong>{{ 'tableManagement.cardLists.assignDateShort' | translate }} (*)</strong>
                </label>
                <div class="p-3"></div>
                <p-calendar [(ngModel)]='startDate' [showTime]='false' [style]="{'width':'200px'}"
                    dateFormat='{{i18n.dateFormat}}' showIcon='true' appendTo='body' [firstDayOfWeek]="1" [minDate]="minStartDate" 
                    [maxDate]="maxStartDate" ></p-calendar>
            </div>

            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
					{{ 'tableManagement.cardLists.deassignDateShort' | translate }}
                </label>
                <div class="p-3"></div>
                <p-calendar [(ngModel)]='endDate' [showTime]='false' [style]="{'width':'200px'}"
                    dateFormat='{{i18n.dateFormat}}' showIcon='true' appendTo='body' [firstDayOfWeek]="1"></p-calendar>
            </div>
        </div>

    </div>
    <!-- #endregion BODY -->

    <!-- #region FOOTER -->
    <p-footer>
        <div class="d-flex justify-content-center bd-highlight">
            <div class="p-2 bd-highlight">
                <div *ngIf="!isNew">
                    <button class="btn custom-button" (click)="save()" [disabled]="!canUpdate" i18n>
                        {{'general.save' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </p-footer>
    <!-- #endregion FOOTER -->

</p-dialog>